import React, { Component } from 'react'
import { Select, DatePicker, Icon } from 'antd'
import moment from 'moment'
import { _convertObject } from "../../../helpers/convertObject"
import GarmentQuantityStatisticsTable from './table/GarmentQuantityStatisticsTable'
import { statisticSewed, exportStatisticSewed } from "../../../services/api/3dApi"
import store from 'store'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import ReactHTMLTableToExcel from "react-html-table-to-excel";


class GarmentQuantityStatisticsPage extends Component {
    storeName = 'GarmentQuantityStatisticsFilter'
    checkStoreValue = (field, value) => {
        return store.get(this.storeName) !== undefined ? store.get(this.storeName)[field] : value
    }
    state = {
        batches: [],
        total: 0,
        loading: false,
        error: '',
        filters: {
            mark_sewed_date: moment().format('YYYY-MM-DD'),
            sort: 'time_slot',
        },
        totalWithTimeSlot: {},
        totalBatchesWithoutMoved: 0
    }

    callApiOnExactHour = () => {
        const currentHour = moment().format("HH:mm:ss")
        if (currentHour.includes(':00:00') || currentHour.includes(':30:00')) {
            this._fetchBatches()
        }
    }

    componentDidMount() {
        this.setState(({ filters }) => {
            return {
                filters: {
                    ...filters,
                },
            }
        }, this._fetchBatches)

        this.timer = setInterval(() => {
            this.callApiOnExactHour();
        }, 1000);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.filters.mark_sewed_date !== prevState.filters.mark_sewed_date) {
            const currentTime = moment()
            if (this.state.filters.mark_sewed_date === currentTime.format('YYYY-MM-DD')) {
                clearInterval(this.timer);
                this.timer = setInterval(() => {
                    this.callApiOnExactHour();
                }, 1000);
            } else {
                clearInterval(this.timer);
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    _handleUpdateStorage = (params) => {
        const storage = store.get('GarmentQuantityStatisticsFilter')

        store.set('GarmentQuantityStatisticsFilter', {
            ...storage,
            ...params
        })
    }

    _fetchBatches = async () => {
        this.setState({
            loading: true,
        })

        try {
            const { filters } = this.state
            let payload = {
                ...filters,
            }
            const { data: response } = await statisticSewed(payload)
            const { data: res, success, error } = response

            if (!success) {
                this.setState({
                    error: error,
                    loading: false
                })
            }

            const { data, total, totalWithTimeSlot, totalBatchItemSewingWithoutSewed} = { ...res }
            const totalBatchItemSewingWithoutSewedValues = Object.values(totalBatchItemSewingWithoutSewed)

            const batches = data.map(item => {
                const totalItemWithoutMoved = totalBatchItemSewingWithoutSewed[item.sewing_partner_info.id] ? totalBatchItemSewingWithoutSewed[item.sewing_partner_info.id].total_item_without_moved : 0
                const batchItem = {
                    ...item,
                    total_item_without_moved: totalItemWithoutMoved

                }

                return batchItem
            })

            const batchesIdsExist = data.map(item => {
                return item.sewing_partner_info.id
            })

            const totalBatchItemSewingWithoutSewedValuesOther = totalBatchItemSewingWithoutSewedValues.filter(item => !batchesIdsExist.includes(item.sewing_partner_info.id))
            const batchesFinal = [...batches, ...totalBatchItemSewingWithoutSewedValuesOther]

            let totalBatchesWithoutMoved  = 0;
            batchesFinal.map(batchItem => {
                totalBatchesWithoutMoved += batchItem.total_item_without_moved
            });

            this.setState({
                batches: batchesFinal  || [],
                total,
                totalWithTimeSlot,
                totalBatchesWithoutMoved,
                loading: false,
                error: '',
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _handleChangeDate = (dateString) => {
        const currentTime = moment().format('YYYY-MM-DD')
        const { filters } = this.state
        if (dateString !== currentTime) {
            this.setState({
                filters: {
                    ...filters,
                    mark_sewed_date: dateString,
                    sort: 'total'
                },
            }, this._fetchBatches)
            return
        }
        if (dateString === currentTime) {
            this.setState({
                filters: {
                    ...filters,
                    mark_sewed_date: dateString,
                    sort: 'time_slot'
                },
            }, this._fetchBatches)
            return
        }
    }

    _handleChangeSort = (value) => {
        const { filters } = this.state
        this.setState({
            filters: {
                ...filters,
                sort: value,
            },
        }, this._fetchBatches)
    }

    _onExport = async () => {
        this.setState({
            loading: true,
        })
        try {
            const { filters } = this.state
            let payload = {
                ...filters,
            }
            const { data: response } = await exportStatisticSewed(payload)
            const { data: res, success, error } = response

            if (!success) {
                this.setState({
                    error: error,
                    loading: false
                })
            }
            if (response) {
                downloadFileFromData(response, { filename: `garment-output-statistics-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            }
            this.setState({
                loading: false,
            })

        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    render() {
        const { batches, error, total, loading, filters, totalWithTimeSlot, totalBatchesWithoutMoved} = this.state
        const newFilter = _convertObject(filters)
        const currentTime = moment().format('YYYY-MM-DD')

        const { Option } = Select
        return (
            <div className='LabelPage GarmentQuantityStatisticsPage'>
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                            <div className='listFilters d-flex'>
                                <div className="sewedDate d-flex mr-3 justify-content-between align-items-center">
                                    <label className='mb-0 mr-3 font-weight-bold'>Ngày đánh dấu may xong</label>
                                    <DatePicker
                                        format={'YYYY-MM-DD'}
                                        defaultValue={moment()}
                                        value={moment(filters.mark_sewed_date)}
                                        onChange={(date, dateString) => this._handleChangeDate(dateString)}
                                        allowClear={false}
                                    />
                                </div>
                                <div className="sortBy d-flex mx-3 justify-content-between align-items-center">
                                    <label className='mb-0 mr-3 font-weight-bold'>Sắp xếp</label>
                                    <Select
                                        showSearch
                                        className=''
                                        showArrow
                                        placeholder='Sắp xếp'
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        value={filters.sort || []}
                                        onChange={(value) => this._handleChangeSort(value)}
                                        style={{ minWidth: '200px' }}
                                    >
                                        <Option value={'total'}>Tổng từng partner</Option>
                                        <Option value={'time_slot'} disabled={filters.mark_sewed_date !== currentTime}>Khung thời gian</Option>

                                    </Select>
                                </div>
                            </div>

                            <div className='d-flex justify-content-between align-items-center'>
                                {/* <Button
                                    type='primary'
                                    icon='export'
                                    className='float-right '
                                    onClick={this._onExport}
                                >
                                    Export
                                </Button> */}
                                <ReactHTMLTableToExcel
                                    id="Export-table-xls-button"
                                    className="Export-table-xls-button btn btn-primary mr-2"
                                    table="ExportTable"
                                    filename={`garment-output-statistics-${moment().format('YYYY-MM-DD-HH-mm-ss')}`}
                                    sheet="GarmentOutputStatistics"
                                    buttonText="Export"
                                ></ReactHTMLTableToExcel>
                            </div>

                        </div>
                        <div>
                            {error && (
                                <div className="text-danger mb-2">{error}</div>
                            )}
                        </div>
                        <GarmentQuantityStatisticsTable
                            newFilter={newFilter}
                            batches={batches}
                            loading={loading}
                            totalWithTimeSlot={totalWithTimeSlot}
                            totalBatchesWithoutMoved={totalBatchesWithoutMoved}
                            total={total}
                            refreshBatches={this._fetchBatches}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default GarmentQuantityStatisticsPage
